import { Grid } from '@mui/material';
import { HSpacer } from '@nx-smartmonkey/ui';
import { PropsWithChildren } from 'react';

import Text, { TextProps } from '../../../react-components/Text';

interface InfoBoxProps {
  title: string;
}

export const InfoBox = ({ title, children }: PropsWithChildren<InfoBoxProps>) => {
  return (
    <div
      style={{
        borderRadius: `4px`,
        border: `1px solid #CACACA`,
      }}
    >
      <Text
        style={{
          padding: `8px`,
          borderBottom: `1px solid #CACACA`,
        }}
      >
        {title}
      </Text>

      {children}
    </div>
  );
};

interface InfoBoxItemProps {
  icon?: React.ReactElement;
  label: string;
  childrenItemProps?: Record<string, any>;
}

export const InfoBoxItem = ({ icon, label, childrenItemProps = {}, children }: PropsWithChildren<InfoBoxItemProps>) => {
  return (
    <Grid container direction="row" style={{ margin: `16px 0` }} alignItems="center">
      {icon ? (
        <>
          {icon}
          <HSpacer small />
        </>
      ) : null}
      <Grid item>
        <Text variant="label">{label}</Text>
      </Grid>
      <HSpacer small />
      <Grid item {...childrenItemProps}>
        {children}
      </Grid>
    </Grid>
  );
};

export const InfoBoxText = (props: React.PropsWithChildren<TextProps> & React.DOMAttributes<TextProps>) => {
  const { children, ...textProps } = props;
  return (
    <Text {...textProps} isBold>
      {children}
    </Text>
  );
};
